import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getShardCatalogSearch } from '../../../api';

export const adminSearchShardCatalogGetSlice = createGetAsyncSlice({
	name: 'AdminSearchShardCatalog',
	receive: true,
	request: true,
	requestHandler: getShardCatalogSearch,
	retainDataOnRequest: true
});
